//import { useEffect, useState } from 'react';
import { Outlet, Link } from 'react-router-dom';

export default function Header () {
    return (
        <div>
            <div id="header">
                <h1>ruby willow</h1>
                <Link to="/bio">bio & cv</Link>
                <Link to="/willow-web">willow web</Link>
                {making.map((thing) => {
                    return (
                        <Link to={`/making/${thing.hyphen}`}>{thing.title}</Link>
                    )
                })}
                <Link to="https://www.instagram.com/windows_n_enter">instagram</Link>
            </div>
            <div id="outlet">
                <Outlet />
            </div>
        </div>
    );
}

export const making = [
    // { //diary
    //     title: "diary",
    //     hyphen: "diary"
    // },
    { //exercises in tension
        title: "exercises in tension",
        hyphen: "exercises-in-tension",
        alt: "a pebble balanced on two threads",
        items: [
            {type: "img", ad: "underneath"},
            {type: "img", ad: "full"},
            {type: "img", ad: "side-colour"}
        ]
    },
    { //antishrine
        title: "antishrine",
        hyphen: "antishrine",
        alt: "wooden plinths arranged in a 16-point compass with metal sculptures on top",
        items: [
            {type: "img", ad: "full-angled"},
            {type: "img", ad: "middle"},
            {type: "img", ad: "rock"},
            {type: "img", ad: "mummy"},
            {type: "img", ad: "triple"},
            {type: "img", ad: "stack"},
            {type: "img", ad: "full-straight"}
        ]
    },
    { //chinese whispers
        title: "chinese whispers",
        hyphen: "chinese-whispers",
        items: [
            {type: "img", ad: "sign"},
            {
                type: "text", 
                text:`chinese whispers was a show made in collaboration with yuze yuan. beforehand, we played a game of
                chinese whispers with a chain of 25 people. for each link in the chain, the previous receiver, now
                whisperer, and the next receiver would sit in silence for two minutes, back to back. the new receiver
                would then write down what they imagined for those two minutes, before transmitting to the next receiver
                in the chain.`},
            {
                type: "text",
                text: `the show was a documentation of the results of that chain, in the main wall, alongside other
                telepathy experiments.`
            },
            {type: "img", ad: "wall-full"},
            {type: "img", ad: "full-prompts"},
            {type: "img", ad: "prompt-stack"},
            {type: "img", ad: "wall-closer"},
            {type: "img", ad: "wall-close"},
            {type: "img", ad: "wall-1-crop"},
            {type: "img", ad: "wall-2-crop"},
        ]
    },
    { //trying to reach it part 3
        title: "trying to reach it part 3",
        hyphen: "trying-to-reach-it-part-3",
        items: [
            {type: "link", link: "https://www.youtube.com/watch?v=zrMDt4ABGCI"}
        ],
    },
    { //world without end
        title: "world without end",
        hyphen: "world-without-end",
        items: [
            {type: "link", link: "https://www.youtube.com/watch?v=eR01LK9bS2U"}
        ],
    },
];